import React from "react";

export default function ProfileInput({
  label,
  type = "text",
  value,
  onChange,
}) {
  return (
    <div>
      <label className="text-xs font-medium text-gray-500 block mb-1.5 pl-0.5">
        {label}
      </label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        className="w-full bg-gray-100 border border-transparent rounded-xl px-4 py-3 text-sm font-semibold text-gray-800 focus:bg-white focus:border-gray-200 focus:ring-2 focus:ring-[#00306b]/5 outline-none transition-all"
      />
    </div>
  );
}
